<template>
  <dialogWrap
    v-model="isShow"
    :title="configData.title"
    :before-close="cancelHandle"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :width="'1010px'"
  >
    <el-steps v-if="!isAddScheme && !lateFeeOpen" :active="active" finish-status="success" align-center>
      <el-step v-for="item of stepsList" @click.native="clickSteps(item.id)" :title="item.title" :key="item.id" />
    </el-steps>
    <component
      ref="component"
      :configData="configData"
      :tableDataFrom="tableDataFrom"
      :configDisabled="configDisabled"
      :tempFormData="tempFormData"
      :leaseSchemeMaxDate="leaseSchemeMaxDate"
      :isAddScheme="isAddScheme"
      :is="stepsList[active].components"
    />
    <template slot="footer">
      <div v-if="isAddScheme || lateFeeOpen" class="footer">
        <el-button @click="cancelHandle" size="small">取消</el-button>
        <el-button @click="calculatePaymentPlan" size="small" type="primary">确定</el-button>
      </div>
      <div v-else>
        <div v-if="active === 0" class="footer">
          <el-button @click="cancelHandle" size="small">取消</el-button>
          <el-button :loading="btnLoading" @click="calculatePaymentPlan" size="small" type="primary">下一步</el-button>
        </div>
        <div v-if="active === 1" class="footer">
          <el-button @click="cancelHandle" size="small">取消</el-button>
          <el-button @click="goStep(0)" size="small">上一步</el-button>
          <el-button @click="confirmHandle" size="small" type="primary">确定</el-button>
        </div>
      </div>
    </template>
  </dialogWrap>
</template>
<script>
import { getPreviewedPlan } from '@/api/domain/orders'
import { ADVANCEPAYMENT_CODE_MAP, AMOUNTTYPE_CODE_MAP, FEE_CODE_MAP, PAYMODE_CODE_MAP, PAYPLANTYPE_CODE_MAP, PAYPOSY_CODE_MAP } from '@/store/dict/rentPlanDict'
import { mapState } from 'vuex'
import AccountReceivable from './components/AccountReceivable.vue'
import SetPaymentPlan from './components/SetPaymentPlan.vue'
import config from './config'
import { isNewOverdue } from '@/pages/utils/overdue'
import { calculateMonths } from '@/utils'

export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    configPaymentPlan: {
      type: Object,
      default: () => ({}),
    },
    configDisabled: {
      type: Boolean,
      default: false,
    },
    isAddScheme: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    const {
      // 表单项
      formItemList,
    } = config.call(this)
    return {
      formItemList,
      tableDataFrom: {
        tableData: [],
      },
      stepsList: [
        {
          id: 0,
          title: '设置支付计划',
          components: SetPaymentPlan,
        },
        {
          id: 1,
          title: '确认对应账单',
          components: AccountReceivable,
        },
      ],
      active: 0,
      isShow: false,
      btnLoading: false,
      leaseSchemeMaxDate: 0,
      configData: {},
      tempFormData: {},
      formData: {
        startTime: '',
        endTime: '',
        payDay: '',
        payMode: '',
        advancePayment: '',
        rentPerPeriod: '',
        rentDay: '',
        amount: '',
        piecewiseList: [
          {
            startMonth: 1,
            endMonth: '',
            amount: '',
          },
        ],
        payPost: PAYPOSY_CODE_MAP.CURRENT_PERIOD, // 0 当期 1 下期
        payPlanType: PAYPLANTYPE_CODE_MAP.FIXED_SCHEME, // 0 固定方案 1 阶梯方案
        amountType: AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD, // 1 每期 2 日租金
        amountAccuracy: 2, // 保留小数 0 取整 2 保留两位小数
        lateFeeProportion: '',
        interestFreeDays: '',
      },
    }
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'rentOrderFeeType' }) // 获取收款项
  },
  watch: {
    show(val) {
      this.isShow = val
      if (val) {
        this.active = this.step - 1
        this.init()
        this.$nextTick(() => {
          this.$refs.component.init()
        })
      }
    },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  computed: {
    ...mapState({
      rentOrderFeeList: (state) => state.global.rentOrderFeeList || [], // 收款项
    }),
    // 是否是新滞纳金
    lateFeeOpen() {
      const { formData } = this.configPaymentPlan
      return isNewOverdue(formData)
    },
  },
  methods: {
    clickSteps(id) {
      if (id === 0 && id !== this.active) {
        this.goStep(id)
      }
    },
    init() {
      this.formData = {
        startTime: '',
        endTime: '',
        payDay: '',
        payMode: '',
        advancePayment: '',
        rentPerPeriod: '',
        rentDay: '',
        amount: '',
        dailyRule: '',
        customerDueDate: '',
        lastPeriodRule: 1,
        piecewiseList: [
          {
            startMonth: 1,
            endMonth: '',
            amount: '',
          },
        ],
        payPost: '', // 0 当期 1 下期
        payPlanType: PAYPLANTYPE_CODE_MAP.FIXED_SCHEME, // 0 固定方案 1 阶梯方案
        amountType: '', // 1 每期 2 日租金
        amountAccuracy: '', // 不足月保留单位 -2元/-1角/0分
        lateFeeProportion: '',
        interestFreeDays: '',
      }

      if (!this.configDisabled) {
        this.formData.payPost = PAYPOSY_CODE_MAP.CURRENT_PERIOD
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
        this.formData.amountAccuracy = 2
      }

      const { formData = {} } = this.configPaymentPlan
      const { fundType, items = [] } = formData

      this.tableDataFrom.tableData = JSON.parse(JSON.stringify(items))

      this.tableDataFrom.tableData.forEach((item, index) => {
        item.num = index + 1
        item.accruedCycle = [item.startCycleDate, item.endCycleDate]
      })

      // 去掉为null的字段
      Object.keys(formData).forEach((item) => {
        if (formData[item] === null) delete formData[item]
      })

      // 可配置区间数
      if (this.isAddScheme) {
        if (formData.rentPeriodType === 3) {
          this.leaseSchemeMaxDate = Number(formData.rentPeriod)
        } else {
          this.leaseSchemeMaxDate = Math.ceil(Number(formData.rentPeriod) / 30)
        }
      } else {
        this.leaseSchemeMaxDate = calculateMonths(formData.endTime, formData.startTime)
      }
      // 首付款、全款、定金、保证金
      if (fundType === FEE_CODE_MAP.YA_JIN || fundType === FEE_CODE_MAP.SHOU_FU_KUAN || fundType === FEE_CODE_MAP.QUAN_KUAN || fundType === FEE_CODE_MAP.DING_JIN || fundType === FEE_CODE_MAP.BAO_ZHENG_JIN) {
        if (!this.configDisabled) {
          this.formData.payMode = PAYMODE_CODE_MAP.DISPOSABLE
          this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.ALL
        }
      }
      // 尾款、滞纳金
      if (fundType === FEE_CODE_MAP.ZHI_NA_JIN || fundType === FEE_CODE_MAP.WEI_KUAN) {
        if (!this.configDisabled) {
          this.formData.payMode = PAYMODE_CODE_MAP.DISPOSABLE
          this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.NOT_ACCEPT
        }
      }
      // 管理费、服务费
      if (fundType === FEE_CODE_MAP.GUAN_LI_FEE || fundType === FEE_CODE_MAP.FU_WU_FEE) {
        if (!this.configDisabled) {
          this.formData.payMode = PAYMODE_CODE_MAP.DISPOSABLE
          this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.ALL
        }
      }

      if (!this.configDisabled) {
        this.formData.advancePayment = this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE ? ADVANCEPAYMENT_CODE_MAP.ALL : ADVANCEPAYMENT_CODE_MAP.FIRST_PERIOD
      }

      // 弹窗标题
      const titleName = this.rentOrderFeeList.length && this.rentOrderFeeList.filter((item) => {
        return item.code === fundType
      })[0].name

      // 获取配置
      const item = this.formItemList.filter((Item) => {
        return Item.code === fundType
      })[0]
      const { popoverConfig, showFormItem, newShowFormItem } = item
      this.formData = Object.assign(this.formData, formData)

      if (this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        this.formData.customerDueDate = formData.dueDate || formData.startTime
        this.formData.payPost = formData.payPost || PAYPOSY_CODE_MAP.RECEIPT_START_DATE
        this.formData.payDay = formData.startTime
      }

      const { payMode, amountAccuracy, advancePayment, customerDueDate, payPlanType, amountType, amount, dailyRule, payPost, payDay, isPayPostCustom } = this.formData

      // 回显金额
      if (payPlanType === PAYPLANTYPE_CODE_MAP.FIXED_SCHEME) {
        if (amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD) {
          this.formData.rentPerPeriod = amount
        }
        if (amountType === AMOUNTTYPE_CODE_MAP.DAILY_RENT) {
          this.formData.rentDay = amount
        }
      } else {
        this.formData.amount = 0
      }

      // 兼容历史方案
      this.tempFormData = {
        payMode: payMode !== '',
        dailyRule: dailyRule !== '',
        payPlanType: payPlanType !== '',
        amountType: amountType !== '',
        rentPerPeriod: this.formData.rentPerPeriod !== '',
        rentDay: this.formData.rentDay !== '',
        amount: amount !== '',
        // 缴款日为空或“自定义”时，可重新编辑payPost、payDay、customerDueDate
        payPost: payPost !== '' && !isPayPostCustom,
        payDay: payDay !== '' && !isPayPostCustom,
        customerDueDate: customerDueDate !== '' && !isPayPostCustom,
        advancePayment: advancePayment !== '',
        amountAccuracy: amountAccuracy !== '',
      }

      if (!this.tempFormData.payPost) {
        // 收款方式为“一次性”时，缴款日默认值为“订单收款起始日”
        if (payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
          // eslint-disable-next-line
          this.formData.payPost = payPost
        } else if (payMode === PAYMODE_CODE_MAP.DAY) {
          // 收款方式为“日付”时，缴款日为空
          this.formData.payPost = ''
        } else {
          // 收款方式为“非一次性”时，缴款日默认值为“当期”
          // eslint-disable-next-line
          this.formData.payPost = isPayPostCustom ? (this.isAddScheme ? payPost : PAYPOSY_CODE_MAP.CURRENT_PERIOD) : (payPost || PAYPOSY_CODE_MAP.CURRENT_PERIOD)
        }
      }

      if (!this.tempFormData.amountAccuracy) {
        this.formData.amountAccuracy = 0
      }

      if (!this.tempFormData.advancePayment) {
        this.formData.advancePayment = this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE ? ADVANCEPAYMENT_CODE_MAP.ALL : ADVANCEPAYMENT_CODE_MAP.FIRST_PERIOD
      }

      if (!this.tempFormData.payMode) {
        if (fundType !== FEE_CODE_MAP.ZU_JIN && fundType !== FEE_CODE_MAP.OTHERS) {
          this.formData.payMode = PAYMODE_CODE_MAP.DISPOSABLE
        }
      }

      this.configData = {
        title: `配置“${titleName}”支付计划`,
        showFormItem: this.lateFeeOpen ? newShowFormItem : showFormItem,
        popoverConfig,
        fundType,
        formData: this.formData,
      }
    },
    cancelHandle() {
      this.$emit('change', false)
    },
    goStep(step) {
      this.active = step
      this.$nextTick(() => {
        this.$refs.component.init()
      })
    },
    // 确定
    confirmHandle() {
      const { customerDueDate, payMode } = this.formData
      let arr = [...this.tableDataFrom.tableData]
      // 是否固定日期
      if (customerDueDate) {
        this.formData.payDay = 1
        this.formData.payDate = customerDueDate
        this.formData.dueDate = customerDueDate
      }

      if (payMode === PAYMODE_CODE_MAP.DAY) {
        this.formData.payDay = 1
      }

      // 过滤不需要的字段
      arr = arr.map((item) => {
        const { dueDate, planAmount, accruedCycle, remarks } = item
        return {
          dueDate,
          endCycleDate: accruedCycle[1],
          planAmount,
          remarks,
          startCycleDate: accruedCycle[0],
        }
      })

      if (this.$refs.component.amountRules) {
        this.$message.error(`账单累计总金额${this.$refs.component.billTotalAmount}元，已超限`)
        return
      }

      let res = false
      this.$refs.component.$refs.otherPayFrom && this.$refs.component.$refs.otherPayFrom.validate((valid) => {
        res = valid
      })

      if (res || this.isAddScheme || this.lateFeeOpen) {
        this.$emit('getParams', {
          formData: this.formData,
          items: arr,
        })
        this.cancelHandle()
      } else {
        this.$message.error('有款项周期未填写完成，请检查后重新提交')
      }
    },
    // 处理金额
    handleArrears() {
      const { payPlanType, amountType, rentPerPeriod, rentDay, fundType, payMode } = this.formData

      if (fundType !== FEE_CODE_MAP.ZU_JIN || (payMode !== PAYMODE_CODE_MAP.FULL_MOON && payMode !== PAYMODE_CODE_MAP.NATURAL_MONTH && payMode !== PAYMODE_CODE_MAP.WEEK)) return
      // 固定方案
      if (payPlanType === PAYPLANTYPE_CODE_MAP.FIXED_SCHEME) {
        if (amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD) {
          this.$refs.component.rentPerPeriodChange()
          this.formData.amount = rentPerPeriod
        }
        if (amountType === AMOUNTTYPE_CODE_MAP.DAILY_RENT) {
          this.$refs.component.rentDayChange()
          this.formData.amount = rentDay
        }
      }
      // 阶梯方案
      if (payPlanType === PAYPLANTYPE_CODE_MAP.LADDER_SCHEME) {
        this.formData.amount = 0
      }
    },
    // 计算支付计划
    calculatePaymentPlan() {
      this.handleArrears()
      let rules = false
      const { component } = this.$refs
      component?.amountChange()
      component?.$refs.form.validate((valid) => {
        rules = valid
      })
      if (!rules) return

      const {
        fundType,
        startTime,
        endTime,
        payPlanType,
        amountType,
        dailyRule,
        payMode,
        payDay,
        lastPeriodRule,
        amountAccuracy,
        piecewiseList,
        amount,
        payPost,
        advancePayment,
        customerDueDate,
      } = this.formData
      const params = {
        rentPlanFeeType: fundType,
        payDay: Number(payDay),
        startTime,
        endTime,
        payPost,
        payMode,
        advancePayment,
        customerDueDate,
        dailyRule: Number(dailyRule),
        lastPeriodRule: Number(lastPeriodRule),
        amountType: Number(amountType),
        amount,
        piecewiseList: payPlanType === PAYPLANTYPE_CODE_MAP.LADDER_SCHEME ? piecewiseList : [],
      }

      if ((fundType === FEE_CODE_MAP.ZU_JIN || fundType === FEE_CODE_MAP.OTHERS) && (payMode === PAYMODE_CODE_MAP.WEEK || payMode === PAYMODE_CODE_MAP.FULL_MOON || payMode === PAYMODE_CODE_MAP.NATURAL_MONTH)) {
        params.amountAccuracy = amountAccuracy
      }

      if (!this.lateFeeOpen && (amount === '' || amount === undefined)) {
        this.$refs.component.amountChange()
        this.$message.warning('请确认收款金额及配置已正确填写')
        return
      }
      if (payPlanType === PAYPLANTYPE_CODE_MAP.LADDER_SCHEME) {
        if (amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD) {
          this.$refs.component.$refs.amountPerPeriod.verify()
        }
        if (amountType === AMOUNTTYPE_CODE_MAP.DAILY_RENT) {
          this.$refs.component.$refs.dailyRent.verify()
        }

        // 校验最后一级结束月份等于预计租赁周期
        const ladderMaxDate = Number(piecewiseList[piecewiseList.length - 1].endMonth)
        // 只有在创建租赁方案和自定义租赁方案时才需要校验区间长度，如果选择了租赁方案则不校验
        if (ladderMaxDate === 0 || (!this.configDisabled && this.leaseSchemeMaxDate !== ladderMaxDate)) {
          this.$message.warning('请确认收款金额及配置已正确填写')
          return
        }

        // 校验金额
        let flag = false
        piecewiseList.forEach((item) => {
          if (item.amount === '') flag = true
        })
        if (flag) {
          this.$message.warning('请确认收款金额及配置已正确填写')
          return
        }
      }

      // 新增租赁方案
      if (this.isAddScheme || this.lateFeeOpen) {
        this.confirmHandle()
        return
      }

      this.btnLoading = true
      getPreviewedPlan(params).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { accruedPlanList = [], totalAmount = 0 } = data || {}
          this.tableDataFrom.tableData = accruedPlanList
          this.configData.formData.receivableTotalAmount = totalAmount
          this.tableDataFrom.tableData.forEach((item, index) => {
            item.num = index + 1
            this.$set(item, 'accruedCycle', [item.startCycleDate, item.endCycleDate])
          })
          this.goStep(1)
        }
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
}
</style>
